module.exports = __webpack_public_path__ + "assets/img/ouzhou.207ce15a.png";